
import { useUserService } from "../../service/user";
import { IUser } from "../../service/user/interfaces/IUser";


const useUpdateUser = () => {
    const {updateUser} = useUserService()
  const updateUserHooks = async (data: IUser) => {
     return await updateUser(data)
  };
  return {
    updateUserHooks,
  };
};

export default useUpdateUser;
